import React from 'react'
import Hero from '../components/Hero/v2/Hero'
import ShoutHOC from '../components/Shout/ShoutHOC'
export default function HeroV2(props) {
  const {
    // businessData,
    // configData,
    // options,
    gonationID,
    variantName,
    locationIndex,
    // city,
    // locations,
    options
  } = props
  const variant = variantName ? variantName : 'heroV2'
  // give the hero shout data
  const Component = ShoutHOC(gonationID, Hero)
  const shoutIsDisabled = options?.shoutDisabled?.[locationIndex]
  if (shoutIsDisabled) {
    return <Hero {...props} variantName={variant} />
  }

  return <Component {...props} variantName={variant} />
}
